import { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import { useFormContext } from 'react-hook-form';
import { Fade, makeStyles } from '@material-ui/core';

import FormSection from '../../form/FormSection';
import ListSelectorField from '../../form/ListSelectorField';
import { useDataService } from '../../../services/ApiDataService';
import {
    DASHBOARDS_ADMIN_GROUPS_FIELD,
    DASHBOARDS_ADMIN_PRIVATE_FIELD,
    DASHBOARD_SHARE_GROUPS_COLUMNS,
} from './DashboardsAdminConstants';

const useStyles = makeStyles({
    selectorWrapper: {
        marginTop: 16,
    },
});

export function DashbaordsAdminGroupsSection({ formData, setGroupsSelectionIsDirty }) {
    const styles = useStyles;
    const { watch } = useFormContext();
    const [groups, setGroups] = useState([]);
    const dataService = useDataService();
    const isPrivate = watch(DASHBOARDS_ADMIN_PRIVATE_FIELD);

    useEffect(() => {
        (async () => {
            const groupsData = await dataService.get('/ipm/v1/admin/groups');
            setGroups(groupsData);
        })();
    }, [dataService]);

    return (
        <Fade in={!isPrivate}>
            <div>
                <FormSection title={t`Share With Groups`}>
                    <div className={styles.selectorWrapper}>
                        <ListSelectorField
                            gridColumns={DASHBOARD_SHARE_GROUPS_COLUMNS}
                            dataArray={groups}
                            fieldName={DASHBOARDS_ADMIN_GROUPS_FIELD}
                            dataArraySearchFields={['groupName']}
                            dbSelected={formData?.groups || []}
                            addButtonText={t`Add Groups`}
                            removeButtonText={t`Remove`}
                            setSelectionIsDirty={setGroupsSelectionIsDirty}
                            selectedEmptyGridText={t`This Dashboard has not been shared with any groups`}
                        />
                    </div>
                </FormSection>
            </div>
        </Fade>
    );
}
